module.exports = __webpack_public_path__ + "static/sign-4dfceee5821ecf106537871c26184fc7.png";